import type { SxProps, Theme } from '@mui/material';

export const homeStackSx: SxProps<Theme> = {};
